import { render } from "./ChatBotComponent.vue?vue&type=template&id=52a0a983&scoped=true"
import script from "./ChatBotComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&lang=js"

import "./ChatBotComponent.vue?vue&type=style&index=0&id=52a0a983&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a0a983"]])

export default __exports__